import { APIErrorResponse, isAPIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

import Identity from './identity';
import enforceRecaptcha, { RecaptchaMethod } from '../utils/enforceRecaptcha';
import { headers } from './constants';
/**
 * Request a one time access Link. The API will create a nonce and trigger an event so that the nonce can be communicated to the user (via email, for example). The user can then call `redeemOTALink(nonce)` to log in with the one time access link.
 *
 * @param email
 *
 * @returns __Promise__ which resolves to `true` if successful.
 *
 * <details>
 * <summary>
 * On error (throws)
 * </summary>
 *
 * ```
 * See documentation for corresponding error codes:
 * https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-identity-v1.json#/Authentication/requestMagicLink
 * ```
 * </details>
 */
export default function requestOTALink(
  email: string,
  recaptchaToken?: string
): Promise<boolean | APIErrorResponse> {
  return enforceRecaptcha(RecaptchaMethod.MAGIC_LINK, recaptchaToken).then(() =>
    fetch(`${Identity.apiOrigin}/identity/public/v1/auth/magiclink`, {
      method: 'POST',
      headers,
      body: JSON.stringify({ email, recaptchaToken })
    })
      .then(JSONResponseHandler)
      .then(json => {
        if (isAPIErrorResponse(json)) {
          throw json;
        } else {
          return true;
        }
      })
  );
}
